import { ShwEnv } from '@/constants/types'

export const COOKIE_REFERRAL_CODE = 'shw-ref-c'
export const COOKIE_SAT_INVITE_CODE = 'shw-sat-invite-c'
export const COOKIE_SAT_INVITATION_PARAMS = 'shw-sat-invite-params-c'
export const COOKIE_SAT_REFERRAL_CODE = 'shw-sat-ref-c'
export const COOKIE_PRIMARY_INTEREST = 'shw-primary-interest-c'

// Set this to true to disable the SAT RCT for future invited users, if we hit capacity
export const SAT_RCT_IS_FULL = false

export const WEBSITE_SETTINGS_MAP = {
  [ShwEnv.TESTING]: {
    websiteName: null,
    vapidPublicKey: null,
    cloudAIRelayWsUrl: null,
    fingerprintAPIKey: null,
    yotiSdkId: null,
  },
  [ShwEnv.DEVELOPMENT]: {
    websiteName: 'localhost:3000',
    vapidPublicKey:
      'BGtPEmyrsDhxhnaocA9LzOS5dQYiZ5Apf6-7ez5BXRxyWciLpG-MstVnNslkP0v4u78-bUWFkx8W7yZJ_Q6Ay-4',
    cloudAIRelayWsUrl: 'ws://localhost:3001/chat',
    fingerprintAPIKey: 'SiFrpUIk93QgMzR5KsZa',
    yotiSdkId: '5106afc8-2dff-48ee-b2ef-22e5ce3c64f0',
  },
  [ShwEnv.STAGING]: {
    websiteName: 'shw-dev.com',
    vapidPublicKey:
      'BENqdEcC_GQymjgLvvZU_yj48qtiiIHc10HSlBZS_AOEfaJiCUtuSgSblRsCM1T_MzIqr-TGl1Snjf4xJQ8nFQw',
    cloudAIRelayWsUrl: 'wss://v0-0-6---cloud-ai-relay-nv72zear7a-ue.a.run.app/chat',
    fingerprintAPIKey: 'WoW98bqQaPHQlOQS4QtO',
    yotiSdkId: '110aa31b-0a2a-46ac-a6e4-55fc60ce8cc7',
  },
  [ShwEnv.PRODUCTION]: {
    websiteName: 'schoolhouse.world',
    vapidPublicKey:
      'BGv9E3YsXuABG17E4Tp5Us5deQhxYeYo0hhVrEXyC6dmKUFAMhpx8aQo5xjqLZDgnRtsuMGrDq7hu1Yqb1PCW0I',
    cloudAIRelayWsUrl: 'wss://v0-0-6---cloud-ai-relay-nv72zear7a-ue.a.run.app/chat',
    fingerprintAPIKey: 'dHqy153k1CT2R2ZbwGIt',
    yotiSdkId: 'df6401c7-fea3-42ce-80bb-a89233990a03',
  },
} satisfies Record<
  ShwEnv,
  {
    websiteName: string | null
    vapidPublicKey: string | null
    cloudAIRelayWsUrl: string | null
    fingerprintAPIKey: string | null
    yotiSdkId: string | null
  }
>

// eslint-disable-next-line no-underscore-dangle
const rawEnv = globalThis.__SHW_ENV__?.SHW_ENV ?? process.env.SHW_ENV ?? ''
const websiteEnv: ShwEnv = rawEnv !== '' ? (rawEnv as ShwEnv) : ShwEnv.DEVELOPMENT

export const WEBSITE_ENV = websiteEnv
export const IS_DEVELOPMENT = websiteEnv === ShwEnv.DEVELOPMENT

/* eslint-disable no-underscore-dangle */
function getHasuraEndpoints(): { hasuraEndpoint: string; hasuraEndpointRo: string } {
  const hasuraEndpoint =
    globalThis.__SHW_ENV__?.HASURA_ENDPOINT ?? process.env.HASURA_ENDPOINT ?? ''
  const hasuraEndpointRo =
    globalThis.__SHW_ENV__?.HASURA_ENDPOINT_RO ?? process.env.HASURA_ENDPOINT_RO ?? hasuraEndpoint
  return { hasuraEndpoint, hasuraEndpointRo }
}
/* eslint-enable no-underscore-dangle */

const { hasuraEndpoint, hasuraEndpointRo } = getHasuraEndpoints()
const baseSettings = WEBSITE_SETTINGS_MAP[websiteEnv]
export const WEBSITE_SETTINGS = {
  ...baseSettings,
  hasuraHttpUrl: `${hasuraEndpoint}/v1/graphql`,
  hasuraWsUrl: `${hasuraEndpointRo.replace(/^http/, 'ws')}/v1/graphql`,
  hasuraReadOnlyHttpUrl: hasuraEndpointRo !== '' ? `${hasuraEndpointRo}/v1/graphql` : null,
}

// Used for showing example bios during onboarding
export const ONBOARDING_EXAMPLE_BIO_USERS = [
  260750, 260745, 260660, 260627, 260577, 260920, 260991, 260804, 260792, 260774,
]

// Start with `DEV_FAKE_USER_ID=<user_id> yarn dev`to log in as a specific user
export const DEV_FAKE_USER_ID = Number(process.env.DEV_FAKE_USER_ID) || null

if (DEV_FAKE_USER_ID != null && (DEV_FAKE_USER_ID < 1 || Number.isNaN(DEV_FAKE_USER_ID))) {
  throw new Error(
    'Please set DEV_FAKE_USER_ID in client/settings to either null or a user id (not 0)'
  )
}
